module.exports = __webpack_public_path__ + "static/media/hci_logo.b42bb94c.png";